import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import Add from '@material-ui/icons/Add';
import Save from '@material-ui/icons/Save';
import { useParams } from 'react-router';
import DataRowEntry from './DataRowEntry';
import { InspectionDataType, StepType } from '../../../api/jurisdiction';
import { useDeleteJurisdictionRequestResultMutation, useGetJurisdictionRequestResultQuery, usePersistJurisdictionRequestResultMutation } from '../../../redux/rtkQuery/apiWikiInspectionSlice';
import { objectKeysToSnakeCase } from '../../../utils';

type Props = {
  header: string;
  rows: StepType[];
  inspectionType: InspectionDataType;
};
const TableSection: FC<Props> = ({ header, rows, inspectionType }) => {
  const [_rows, setRows] = useState<StepType[]>([]);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  // @ts-ignore
  const { wikiId } = useParams();
  const [persistJurisdictionRequestResult] = usePersistJurisdictionRequestResultMutation();
  const [deleteJurisdictionRequestResult] = useDeleteJurisdictionRequestResultMutation();
  const { refetch } = useGetJurisdictionRequestResultQuery({ id: wikiId });
  useEffect(() => {
    if (rows) {
      setRows(rows);
    }
  }, [rows]);
  const onAdd = () => {
    const lastItem = _rows[_rows.length - 1];
    const newRows = [
      ..._rows,
      {
        recordType: inspectionType,
        requestOrResult: '',
      },
    ];
    setRows(newRows);
  };

  const setData = (index, rowData) => {
    const newRows = _rows.map((row, ndx) => {
      if (ndx === index) {
        return rowData;
      }
      return row;
    });
    setRows(newRows);
  };

  const onSaveTable = async () => {
    setShowSuccess(true);
    const apiData = { request_result_data: objectKeysToSnakeCase(_rows) };
    await persistJurisdictionRequestResult({ id: wikiId, data: apiData });
    await refetch();
    setTimeout(() => {
      setShowSuccess(false);
    }, 1500);
  };

  const onDelete = async id => {
    await deleteJurisdictionRequestResult({ id });
    await refetch();
  };
  return (
    <Table>
      <TableHeader>
        {header}
        <IconWrapper>
          {showSuccess && <Success>Success</Success>}
          <Add onClick={onAdd} />
        </IconWrapper>
      </TableHeader>
      <DataRows>{..._rows.map((r, index) => <DataRowEntry key={index} data={r} onSaveTable={onSaveTable} setData={rowData => setData(index, rowData)} onDelete={onDelete} />)}</DataRows>
    </Table>
  );
};

export default TableSection;

const Table = styled.div`
  width: 100%;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: var(--neutral-100);
  border-bottom: 1px solid var(--border);
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--mainText);
`;

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;

  svg {
    cursor: pointer;
    color: var(--neutral-500);
    font-size: 1.25rem;
    transition: color 0.15s ease;
  }

  svg:hover {
    color: var(--primary-600);
  }
`;

const Success = styled.div`
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--success-600);
`;

const DataRows = styled.div`
  flex: 1;
  padding: 8px 0;
  overflow: auto;
`;
